import PopoverMenu from "./PopoverMenu/PopoverMenu"
import useLocalSearchPopoverMenu from "./PopoverMenu/useLocalSearchPopoverMenu"
import usePopoverMenu from "./PopoverMenu/usePopoverMenu"
import PopoverMultiSelect from "./PopoverMultiSelect/PopoverMultiSelect"
import useCustomerContactsPopoverMultiSelect from "./PopoverMultiSelect/useCustomerContactsPopoverMultiSelect"
import useLocationsPopoverMultiSelect from "./PopoverMultiSelect/useLocationsPopoverMultiSelect"
import usePopoverMultiSelect from "./PopoverMultiSelect/usePopoverMultiSelect"
import useStaffsPopoverMultiSelect from "./PopoverMultiSelect/useStaffsPopoverMultiSelect"
import useTagsPopoverMultiSelect from "./PopoverMultiSelect/useTagsPopoverMultiSelect"
import useAccountsPopoverSelect from "./PopoverSelect/useAccountsPopoverSelect"
import useAccountTypesPopoverSelect from "./PopoverSelect/useAccountTypesPopoverSelect"
import useCustomersPopoverSelect from "./PopoverSelect/useCustomersPopoverSelect"
import useEntitiesPopoverSelect from "./PopoverSelect/useEntitiesPopoverSelect"
import useJobsPopoverSelect from "./PopoverSelect/useJobsPopoverSelect"
import useLocationsPopoverSelect from "./PopoverSelect/useLocationsPopoverSelect"
import useStaffsPopoverSelect from "./PopoverSelect/useStaffsPopoverSelect"
import useTagsPopoverSelect from "./PopoverSelect/useTagsPopoverSelect"
import useVendorsPopoverSelect from "./PopoverSelect/useVendorsPopoverSelect"

import type { PopoverMenuProps } from "./PopoverMenu/types"

// The presentational PopoverSelect + list primitives live in shared-web so they
// can be reused outside the staff web app (e.g. web-cxa). The data-bound hooks
// below stay here because they depend on web's API layer.
export {
  PopoverDualSelect,
  PopoverList,
  PopoverListEmpty,
  PopoverListItem,
  PopoverSelect,
  usePopoverSelect,
  useLocalSearchPopoverSelect,
} from "shared-web/components/composite/popover"

export {
  /* PopoverSelect data hooks */
  useCustomersPopoverSelect,
  useJobsPopoverSelect,
  useVendorsPopoverSelect,
  useLocationsPopoverSelect,
  useLocationsPopoverMultiSelect,
  useStaffsPopoverSelect,
  useAccountsPopoverSelect,
  useAccountTypesPopoverSelect,
  useEntitiesPopoverSelect,
  useTagsPopoverSelect,

  /* PopoverMultiSelect */
  PopoverMultiSelect,
  usePopoverMultiSelect,
  useCustomerContactsPopoverMultiSelect,
  useStaffsPopoverMultiSelect,
  useTagsPopoverMultiSelect,

  /* PopoverMenu */
  PopoverMenu,
  PopoverMenuProps,
  usePopoverMenu,
  useLocalSearchPopoverMenu,
}

export type {
  PopoverComboboxItem,
  PopoverListItemProps,
  CustomItem,
  UseLocalSearchPopoverSelectProps,
  UseLocalSearchPopoverSelectRes,
} from "shared-web/components/composite/popover"

export type { UsePopoverMenuRes } from "./PopoverMenu/types"
export type { UseCustomersPopoverSelectRes } from "./PopoverSelect/useCustomersPopoverSelect"
export type { UseJobsPopoverSelectRes } from "./PopoverSelect/useJobsPopoverSelect"
export type { UseLocationsPopoverMultiSelectRes } from "./PopoverMultiSelect/useLocationsPopoverMultiSelect"
export type { UseStaffsPopoverMultiSelectRes } from "./PopoverMultiSelect/useStaffsPopoverMultiSelect"
export type { UseTagsPopoverMultiSelectRes } from "./PopoverMultiSelect/useTagsPopoverMultiSelect"
export type { UseStaffsPopoverSelectRes } from "./PopoverSelect/useStaffsPopoverSelect"
export type { UseTagsPopoverSelectRes } from "./PopoverSelect/useTagsPopoverSelect"
